import axios from 'axios';
import { getApiBaseUrl } from '../apiBase';

function api() {
    return axios.create({
        baseURL: getApiBaseUrl(),
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    });
}

export async function getMySportProfile() {
    const { data } = await api().get('/sport-profile/my');
    return data;
}

export async function updateSportProfile(dto) {
    const { data } = await api().put('/sport-profile/my', dto);
    return data;
}

export async function updateVisibility(dto) {
    const { data } = await api().put('/sport-profile/my/visibility', dto);
    return data;
}

export async function updateProfileSlug(newSlug) {
    const { data } = await api().put('/sport-profile/my/slug', { newSlug });
    return data;
}

export async function getPublicSchoolProfile(slug) {
    const { data } = await axios.get(`${getApiBaseUrl()}/marketplace/school/${slug}`);
    return data;
}

export async function getQualificationSystems() {
    const { data } = await api().get('/sport-profile/qualification-systems');
    return data;
}

export async function addAchievement(dto) {
    const { data } = await api().post('/sport-profile/achievements', dto);
    return data;
}

export async function updateAchievement(id, dto) {
    const { data } = await api().put(`/sport-profile/achievements/${id}`, dto);
    return data;
}

export async function deleteAchievement(id) {
    await api().delete(`/sport-profile/achievements/${id}`);
}

export async function addQualification(dto) {
    const { data } = await api().post('/sport-profile/qualifications', dto);
    return data;
}

export async function addCareerEntry(dto) {
    const { data } = await api().post('/sport-profile/career', dto);
    return data;
}

export async function addEducation(dto) {
    const { data } = await api().post('/sport-profile/education', dto);
    return data;
}

export async function uploadProfilePhoto(file) {
    const form = new FormData();
    form.append('file', file);
    const { data } = await api().post('/sport-profile/my/photo', form);
    return data;
}

export async function uploadProfileCover(file) {
    const form = new FormData();
    form.append('file', file);
    const { data } = await api().post('/sport-profile/my/cover', form);
    return data;
}

export async function searchMarketplace(params) {
    const { data } = await axios.get(`${getApiBaseUrl()}/marketplace/search`, { params });
    return data;
}

export async function getPublicProfile(slug) {
    const { data } = await axios.get(`${getApiBaseUrl()}/marketplace/profile/${slug}`);
    return data;
}

export async function getMarketplaceProducts(targetType) {
    const { data } = await axios.get(`${getApiBaseUrl()}/marketplace/purchase/products`, {
        params: targetType ? { targetType } : undefined,
    });
    return data;
}

export async function getMyPurchases() {
    const { data } = await api().get('/marketplace/purchase/my');
    return data;
}

export async function purchasePromotion(dto) {
    const { data } = await api().post('/marketplace/purchase', dto);
    return data;
}

export async function submitVerification(formData) {
    const { data } = await api().post('/verification/submit', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
    return data;
}

export async function getMyVerifications() {
    const { data } = await api().get('/verification/my');
    return data;
}

export async function toggleFavorite(profileId, add) {
    if (add) await api().post(`/marketplace/favorites/${profileId}`);
    else await api().delete(`/marketplace/favorites/${profileId}`);
}

export async function getFavorites() {
    const { data } = await api().get('/marketplace/favorites');
    return data;
}

export async function sendInquiry(dto) {
    const { data } = await api().post('/marketplace/inquiries', dto);
    return data;
}

export function adminApi() {
    return api();
}
